import { data } from '../../svg/Save/data';
import { makeIcon } from '../makeIcon';

export const Save = makeIcon(data, 'save', 'Save');

export default Save;
